import React from 'react';
import Icon from '../../../components/AppIcon';

const TrailerSpecifications = ({ specifications }) => {
  const specCategories = [
    {
      title: 'Dimensions',
      icon: 'Ruler',
      specs: [
        { label: 'Length', value: specifications?.length },
        { label: 'Width', value: specifications?.width },
        { label: 'Height', value: specifications?.height }
      ]
    },
    {
      title: 'Capacity',
      icon: 'Weight',
      specs: [
        { label: 'Weight Capacity', value: specifications?.weightCapacity },
        { label: 'Payload', value: specifications?.payload },
        { label: 'Tongue Weight', value: specifications?.tongueWeight }
      ]
    },
    {
      title: 'Hitch & Towing',
      icon: 'Link',
      specs: [
        { label: 'Hitch Size', value: specifications?.hitchSize },
        { label: 'Hitch Type', value: specifications?.hitchType },
        { label: 'Brake System', value: specifications?.brakeSystem }
      ]
    },
    {
      title: 'Construction',
      icon: 'Wrench',
      specs: [
        { label: 'Frame Material', value: specifications?.frameMaterial },
        { label: 'Deck Material', value: specifications?.deckMaterial },
        { label: 'Axle Type', value: specifications?.axleType }
      ]
    }
  ];

  return (
    <div className="bg-card rounded-lg shadow-elevation-2 p-4 md:p-6 lg:p-8">
      <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground mb-6">
        Specifications
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
        {specCategories?.map((category, index) => (
          <div key={index} className="space-y-4">
            <div className="flex items-center space-x-3 pb-3 border-b border-border">
              <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={category?.icon} size={20} color="var(--color-primary)" strokeWidth={2} />
              </div>
              <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground">
                {category?.title}
              </h3>
            </div>

            <div className="space-y-3">
              {category?.specs?.map((spec, specIndex) => (
                <div key={specIndex} className="flex justify-between items-center">
                  <span className="font-body text-sm md:text-base text-muted-foreground">
                    {spec?.label}
                  </span>
                  <span className="font-body text-sm md:text-base font-medium text-foreground">
                    {spec?.value}
                  </span>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
      {specifications?.features && specifications?.features?.length > 0 && (
        <div className="mt-8 pt-6 border-t border-border">
          <h3 className="font-heading text-lg md:text-xl font-semibold text-foreground mb-4">
            Special Features
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
            {specifications?.features?.map((feature, index) => (
              <div key={index} className="flex items-center space-x-2">
                <Icon name="CheckCircle2" size={18} color="var(--color-success)" strokeWidth={2} />
                <span className="font-body text-sm md:text-base text-foreground">
                  {feature}
                </span>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default TrailerSpecifications;